/**
 * Mobile Recents / Missed / Voicemail and directory search are on for every
 * mobile main-tab user. Chat-extension stays dialpad-only via `src === 'main'`
 * in `MobileLandingPage` / `enableFeatureParitySearch`.
 */
export function isMobileFeatureParityEnabledForCurrentUser(): boolean {
  return true;
}
